<template>
  <div id="app" class="min-h-screen bg-canvas text-ink no-tap-highlight">
    <router-view v-slot="{ Component }">
      <transition name="page" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <Toast />
    <BottomNav v-if="showBottomNav" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useUIStore } from '@/stores/ui'
import Toast from '@/components/common/Toast.vue'
import BottomNav from '@/components/common/BottomNav.vue'

const route = useRoute()
const authStore = useAuthStore()
const uiStore = useUIStore()

const showBottomNav = computed(() => {
  const hiddenRoutes = ['/login', '/', '/select-truck', '/select-truck-3pl', '/select-new-truck', '/select-new-truck-3pl', '/select-store']
  return authStore.isAuthenticated && !hiddenRoutes.includes(route.path)
})

onMounted(async () => {
  await authStore.loadFromStorage()
  uiStore.loadSelectedTruck()
  uiStore.loadSelectedStore()

  window.addEventListener('online', () => uiStore.setOnlineStatus(true))
  window.addEventListener('offline', () => uiStore.setOnlineStatus(false))
})
</script>

<style>
#app {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Route transition — subtle fade-up, almost imperceptible but gives a sense of motion */
.page-enter-active,
.page-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}
.page-enter-from {
  opacity: 0;
  transform: translateY(6px);
}
.page-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
